import { Route } from '@angular/router'
import { PageLayout, setLayout } from '@baboor/common-page-layouts'

export type PublicWebsiteRoutes = {
    host: Route
    catchAll: Route
}

export const publicWebsiteRoutes: PublicWebsiteRoutes = {
    host: {
        path: ':slug',
        data: { isPublicWebsite: true },
        resolve: { layout: setLayout(PageLayout.Blank) },
        loadComponent: () =>
            import('./public-website-host.component').then(
                (m) => m.PublicWebsiteHostComponent,
            ),
        children: [
            {
                path: '',
                data: { isPublicWebsite: true, sectionTitle: '' },
                loadComponent: () =>
                    import('./public-home.component').then(
                        (m) => m.PublicHomeComponent,
                    ),
            },
            {
                path: 'services',
                data: { isPublicWebsite: true, sectionTitle: 'Services' },
                loadComponent: () =>
                    import('./theme-page-wrapper.component').then(
                        (m) => m.PublicWebsiteSectionComponent,
                    ),
            },
            {
                path: 'team',
                data: { isPublicWebsite: true, sectionTitle: 'Team' },
                loadComponent: () =>
                    import('./theme-page-wrapper.component').then(
                        (m) => m.PublicWebsiteSectionComponent,
                    ),
            },
            {
                path: 'gallery',
                data: { isPublicWebsite: true, sectionTitle: 'Gallery' },
                loadComponent: () =>
                    import('./theme-page-wrapper.component').then(
                        (m) => m.PublicWebsiteSectionComponent,
                    ),
            },
            {
                path: 'promotions',
                data: { isPublicWebsite: true, sectionTitle: 'Promotions' },
                loadComponent: () =>
                    import('./theme-page-wrapper.component').then(
                        (m) => m.PublicWebsiteSectionComponent,
                    ),
            },
            {
                path: 'contact',
                data: { isPublicWebsite: true, sectionTitle: 'Contact' },
                loadComponent: () =>
                    import('./theme-page-wrapper.component').then(
                        (m) => m.PublicWebsiteSectionComponent,
                    ),
            },
            {
                path: 'book',
                data: {
                    isPublicWebsite: true,
                    sectionTitle: 'Book Appointment',
                },
                loadComponent: () =>
                    import('./theme-page-wrapper.component').then(
                        (m) => m.PublicWebsiteSectionComponent,
                    ),
            },
            {
                path: 'confirmation/:id',
                data: {
                    isPublicWebsite: true,
                    sectionTitle: 'Booking Confirmed',
                },
                loadComponent: () =>
                    import('./theme-page-wrapper.component').then(
                        (m) => m.PublicWebsiteSectionComponent,
                    ),
            },
            {
                path: 'my-appointments',
                data: {
                    isPublicWebsite: true,
                    sectionTitle: 'My Appointments',
                },
                loadComponent: () =>
                    import('./theme-page-wrapper.component').then(
                        (m) => m.PublicWebsiteSectionComponent,
                    ),
            },
            {
                path: 'waitlist',
                data: { isPublicWebsite: true, sectionTitle: 'Waitlist' },
                loadComponent: () =>
                    import('./public-waitlist/public-waitlist.component').then(
                        (m) => m.PublicWaitlistComponent,
                    ),
            },
        ],
    },
    catchAll: {
        path: '**',
        data: { isPublicWebsite: true },
        loadComponent: () =>
            import('./custom-domain-host.component').then(
                (m) => m.CustomDomainHostComponent,
            ),
    },
}
